import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../utils/axiosConfig";

import RideDetails from "./RideDetails";
import { useSettings } from "../hooks/useSettings";
import { removeQuery } from "../utils/queryHelpers";
import RideDataDisplay from "./RideDataDisplay";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ display: value === index ? 'block' : 'none' }}
    >
      {
        value === index && <div>{
          children}</div>
      }
    </div>
  );
}

const DetailsSidePanel = ({
  DId = "",
  anchor,
  toggleDrawer,
  specialFilter,
  role = "",
  fetchFunction = () => {},
  setDriverId = () => {},
}) => {
  const [sidePanelData, setSidePanelData] = useState({});
  const [riderId, setRiderId] = useState("");
  const [tabs, setTabs] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();

  const [priceBreakupObj, setPriceBreakupObj] = useState({});

  const [payment, setPayment] = useState({
    payment_mode: "",
    payment_status: "",
  });

  const navigate = useNavigate();

  const handleNavigate = () => {
    let driverId = sidePanelData?.driver_details?.id ?? "";
    if (driverId) {
      navigate(`/driver/${driverId}`);
    }
  };
  const handleTabsChange = (event, newValue) => {
    setTabs(newValue);
  };

  const { dateformat, timezone, formatDate, timeFormat } = useSettings();

  // Fetching driver Details
  const getDriverDetails = async () => {
    let url = `/crm/ride/${DId}/`;

    if (specialFilter) {
      url += `?special_filter=${specialFilter}`;
    }
    // passing token in headers

    await axiosInstance
      .get(url)
      .then((res) => {
        setSidePanelData(res?.data?.data ?? {});
        let resData = res?.data?.data ?? {};
        setPriceBreakupObj({
          bookfare: resData?.price_breakup?.booking_fee ?? "",
          baseFare: resData?.price_breakup?.base_fare ?? "",
          distance_fee_per_km:
            resData?.price_breakup?.distance_fee_per_km ?? "",
          ride_time_fee_per_min:
            resData?.price_breakup?.ride_time_fee_per_min ?? "",
          surge_fee: resData?.price_breakup?.surge_fee ?? "",
          coupon_discount_amount:
            resData?.price_breakup?.coupon_discount_amount ?? "",
        });

        setPayment({
          payment_status: resData?.payment_details?.payment_status ?? "",
          payment_mode: resData?.payment_details?.payment_method ?? "",
        });
      })
      .catch((error) => {
        console.error("error while getting driver details by id", error);
      });
  };
  useEffect(() => {
    if (DId) {
      getDriverDetails();
    }
  }, [DId]);

  return (
    <Box
      sx={{
        width: "446px",
        background: "#FFF",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderLeft: "1px solid #E0E0E0",
      }}
    >
      <Box
        sx={{
          padding: "10px 24px",
          borderBottom: "1px solid #E0E0E0",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <Typography
            sx={{
              color: "#1A1C1E",
              fontFamily: "Proxima Nova",
              fontWeight: "600",
              fontSize: "18px",
              lineHeight: "24px",
            }}
          >{`Booking ID: ${sidePanelData?.booking_id ?? ""}`}</Typography>
          <Button
            sx={{
              minWidth: "32px",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              color: "#6F747E",
              padding: 0,
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
                color: "#000",
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              let handleEvevnt = toggleDrawer("right", false);
              removeQuery("customerdrawer", setSearchParams);
              removeQuery("BookingDrawer", setSearchParams);
              removeQuery("id", setSearchParams);

              setSidePanelData({});
              handleEvevnt(e);
            }}
          >
            <CloseIcon fontSize="small" />
          </Button>
        </Box>
        <Typography
          sx={{
            fontFamily: "Proxima Nova",
            fontWeight: "400",
            fontSize: "14px",
            color: "#6F747E",
            lineHeight: "20px",
          }}
        >
          {formatDate(sidePanelData?.created_at ?? "", timezone, dateformat)} •{" "}
          {formatDate(sidePanelData?.created_at, timezone, timeFormat)}
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3 }}>
        <Tabs
          value={tabs}
          onChange={handleTabsChange}
          aria-label="details tabs"
          variant="fullWidth"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontFamily: "Proxima Nova",
              fontWeight: "600",
              fontSize: "15px",
              color: "#6F747E",
              minHeight: "48px",
              "&.Mui-selected": {
                color: "#043A87",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#043A87",
              height: "3px",
              borderRadius: "3px 3px 0 0",
            },
          }}
        >
          <Tab label="Booking Details" value={0} />
          <Tab label="Ride Request Details" value={1} />
        </Tabs>
      </Box>

      <Box sx={{ flex: 1, overflowY: "auto", p: 3 }}>
        <CustomTabPanel value={tabs} index={0}>
          <RideDetails
            sidePanelData={sidePanelData}
            payment={payment}
            specialFilter={specialFilter}
            handleNavigate={handleNavigate}
            role={role}
            setRiderId={setRiderId}
            priceBreakupObj={priceBreakupObj}
            toggleDrawer={toggleDrawer}
            fetchFunction={fetchFunction}
            riderId={riderId}
            anchor={anchor}
            DId={DId}
          />
        </CustomTabPanel>

        <CustomTabPanel value={tabs} index={1}>
          <RideDataDisplay bookingId={sidePanelData?.id ?? ""} />
        </CustomTabPanel>
      </Box>
    </Box>
  );
};

export default DetailsSidePanel;
